module.exports = __webpack_public_path__ + "img/time.49db220a.png";